module.exports = __webpack_public_path__ + "img/home-brands-pan-di-stelle.jpg?6f8dbf23113f1b7ed20acfbca033f11a";